import { render, staticRenderFns } from "./TreeDiaryLike.vue?vue&type=template&id=b172916c&"
import script from "./TreeDiaryLike.vue?vue&type=script&lang=ts&"
export * from "./TreeDiaryLike.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports